export default {"src":"/_next/static/media/speed.976ca86f.svg","height":24,"width":24,"blurWidth":0,"blurHeight":0};